import { Hr } from '@euler/app/components/Hr';
import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { Dropdown, DropdownOption } from '@euler/components/dropdown';
import { FormGroup } from '@euler/components/form';
import { VehicleFuelType } from '@euler/model/enum';
import { memo, useCallback } from 'react';

const kOptions: DropdownOption<VehicleFuelType>[] = [
  { value: VehicleFuelType.Gasoline, label: '汽油' },
  { value: VehicleFuelType.Diesel, label: '柴油' },
  { value: VehicleFuelType.Electric, label: '电动' },
  { value: VehicleFuelType.PluginHybridElectric, label: '插电式混合动力' },
  { value: VehicleFuelType.HybridElectric, label: '混合动力' },
  { value: VehicleFuelType.FuelCell, label: '燃料电池' },
  { value: VehicleFuelType.Methanol, label: '甲醇' },
  { value: VehicleFuelType.Natgas, label: '天然气' },
];

export const FuelTypeField = memo(() => {
  const { form } = useOrderSearchForm();

  const onChange = useCallback(
    (values: VehicleFuelType[] | undefined) => {
      form.vehicleFuelType.update(values);
    },
    [form.vehicleFuelType],
  );

  return (
    <FormGroup label="燃油类型">
      <Dropdown
        mode="multiple"
        options={kOptions}
        value={form.vehicleFuelType.value}
        placeholder="按燃油类型搜索"
        onChange={onChange as any}
        clearable={true}
        withTagsView={true}
        tagRemovable={true}
        ItemSeparatorComponent={() => <Hr color="#ddd" />}
      />
    </FormGroup>
  );
});
